import {
    serverBus
} from '@/main'
import SessionManager from '@/Manager/Session.manager'
import DOMManager from "@/Manager/DOM.manager";
// import StarredChannels from '@/components/LeftSidebar/StarredChannels'

import DefaultChannels from '@/components/LeftSidebar/DefaultChannels/DefaultChannels.vue';
import DirectChannels from '@/components/LeftSidebar/DirectChannels/DirectChannels.vue';
import StarredChannels from '@/components/LeftSidebar/StarredChannels/StarredChannels.vue';
import AllChannels from '@/components/LeftSidebar/AllChannels/AllChannels.vue';

import Global from '@/scripts/Global'
import UserApi from '@/scripts/api/user.api'
import VueSignals from '@/scripts/VueSignals';
import {
    CPUtils
} from '@/scripts/Utils'
import {
    Logging
} from '@/scripts/Logging';
import MainApi from '@/scripts/api/main.api'
import ChannelApi from '@/scripts/api/channel.api';
import UserNotification from '@/Manager/Notification/User.manager'
import ChannelSessionManager from '@/Manager/Session/Channels.manager'
import ChannelHandler from '@/Handler/ChannelHandler'
import {
    User
} from '@/classes/User'

export default {
    name: 'LeftSidebar',
    data() {
        return {
            loggedInUserDoc: SessionManager.getLoggedInUser(),
            arrMentions: [],
            activeChannelDoc: SessionManager.getActiveChannel(),
            channels: SessionManager.getChannels(),
            AlertedChannelsList: [],
            showLeftSidebarMobile: false,
            needsPermission: false,
            showOptionsMenu: false,
            showStatusMode: false,
            draftIsThere: false,
            showNewMessageAlertDown: false,
            showNewMessageAlertUp: false,
            showNewMessageTo: '',
            acceptedInvitationIds: [],
            conventionalView: Global.displayConventionalView()
        }
    },
    components: {
        StarredChannels,
        DefaultChannels,
        DirectChannels,
        AllChannels
    },
    watch: {
        showLeftSidebarMobile(value) {
            if (window.innerWidth <= 900) {
                // For mobile to maintain the status of the leftsidebar
                this.$router.push({ query: { ...this.$router.query, leftSideBarOpen: value } });
            }
        }
    },
    mounted() {

        serverBus.$on(VueSignals.BUS_LOGGEDIN_ARRIVED, (status) => {
            this.ConstructChannels()
        })
        serverBus.$on(VueSignals.HIDE_OPTIONS_MENU, (success) => {
            this.showOptionsMenu = false
            this.showStatusMode = false
        })

        serverBus.$on(VueSignals.DRAFT_IS_THERE, (res) => {
            Logging.Debug(res)
            this.draftIsThere = res
        })

        serverBus.$on(VueSignals.LOADED_MENTIONS, (data) => {
            this.arrMentions = data
        })


        serverBus.$on(VueSignals.LOGGED_IN_USER, (ch_id) => {
            this.loggedInUserDoc = SessionManager.getLoggedInUser()
        })


        serverBus.$on(VueSignals.CHANNEL_LIST_CHANGED, (ch_id) => {
            this.channels = SessionManager.getChannels();
            this.conventionalView = Global.displayConventionalView();
            this.$forceUpdate();
        })

        serverBus.$on(VueSignals.NOTIFICATION_NEED_PERMISSION, (status) => {
            this.needsPermission = status
        })

        serverBus.$on(VueSignals.ALL_MESSAGES_SEEN, (channel_id) => {
            this.MarkAllMessagesSeen(channel_id)
        })

        /**************** remove channel *******************/
        serverBus.$on(VueSignals.REMOVE_CHANNEL, (channel_id) => {
            SessionManager.DestroyChannel(channel_id)
        })

        serverBus.$on(VueSignals.LOADED_CHANNEL_ID, (channel_id) => {
            this.loadChannel(channel_id)
        })

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (ch_id) => {
            this.showLeftSidebarMobile = false // for mobile
            Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, false)

            for (let i = 0; i < this.arrMentions.length; i++) {
                if (this.arrMentions[i].channel_id == SessionManager.getActiveChannelId()) {
                    this.arrMentions.splice(i, 1)
                    break
                }
            }

            this.activeChannelDoc = SessionManager.getActiveChannel()

            for (let i = 0; i < this.channels.length; i++) {
                if (this.channels[i].channel_id == this.activeChannelDoc.channel_id) {
                    this.channels[i] = this.activeChannelDoc
                    break
                }
            }


            this.draftIsThere = this.channels.some(currChannel => {
                return currChannel.direct &&
                    currChannel.user_ids[0] == SessionManager.getLoggedInUserId() &&
                    currChannel.user_ids[1] == SessionManager.getLoggedInUserId()
            })
            Global.globalValue(VueSignals.DRAFT_IS_THERE, this.draftIsThere)
        })


        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL_NAME, (ch_id) => {
            this.activeChannelDoc = SessionManager.getActiveChannel()

            for (let i = 0; i < this.channels.length; i++) {
                if (this.channels[i].channel_id == this.activeChannelDoc.channel_id) {
                    this.channels[i] = this.activeChannelDoc
                    break
                }
            }

        })

        serverBus.$on(VueSignals.ACTIVE_POSSIBLE_CHANGED, (success) => {
            this.showLeftSidebarMobile = false // for mobile
            this.activeChannelDoc = SessionManager.getActiveChannel()
        })


        /**
         *  remove hightlight for invitation
         */
        serverBus.$on(VueSignals.REMOVE_BG_INVITED_CHANNEL, (channel_id) => {
            this.acceptedInvitationIds.splice(
                this.acceptedInvitationIds.indexOf(channel_id, 1))
        })

        serverBus.$on(VueSignals.INVITED_CHANNEL_ACCEPTED, (channel_id) => {

            if (this.acceptedInvitationIds.indexOf(channel_id) < 0) {
                this.acceptedInvitationIds.push(channel_id)
            }

            setTimeout(function() {
                Global.globalValue(VueSignals.REMOVE_BG_INVITED_CHANNEL, channel_id)
                // Global.globalValue(VueSignals.CHANNEL_USERS_CHANGED, true)
                SessionManager.UpdateChannel(channel_id, {
                    "type": "channel"
                })
            }, 3000)
        })

        serverBus.$on(VueSignals.REMOVE_ALL_MENTIONS, (channel_id) => {
            for (let k = 0; k < this.arrMentions.length; k++) {
                if (this.arrMentions[k].channel_id == channel_id) {
                    this.arrMentions[k].count = 0
                }
                Global.setFaviconNormal()
                for (let i = 0; i < this.AlertedChannelsList.length; i++) {
                    if (this.AlertedChannelsList[i] == channel_id) {
                        this.AlertedChannelsList.splice(i, 1)
                        break
                    }
                }
            }
        })

        serverBus.$on(VueSignals.SOCKET_CHANNEL_CREATE, (chatMessage) => {
            if (chatMessage.publish_user_cp_id == SessionManager.getLoggedInUserId()) {
                SessionManager.createChannel(chatMessage.channel_doc)
            }

        })

        /**************** Mark the new message in new channel *******************/
        serverBus.$on(VueSignals.SOCKET_MESSAGE_POSTED, (chatMessage) => {
            let channelMentionNotFound = false
            var message_body = chatMessage.data;
            if (chatMessage.event == VueSignals.SOCKET_MESSAGE_POSTED && typeof message_body != "undefined") {
                let container = document.querySelector(".left-sidebar-holder")

                if (chatMessage.data.user_id != this.loggedInUserDoc.user_id &&
                    document.getElementById(chatMessage.data.channel_id).offsetTop - container.scrollTop + 250) {
                    if (document.getElementById(chatMessage.data.channel_id) != null &&
                        document.getElementById(chatMessage.data.channel_id).getBoundingClientRect().top > container.clientHeight) {
                        this.showNewMessageAlertDown = true
                        this.showNewMessageTo = chatMessage.data.channel_id
                    }

                    if (document.getElementById(chatMessage.data.channel_id) != null &&
                        document.getElementById(chatMessage.data.channel_id).getBoundingClientRect().top < 0 &&
                        document.getElementById(chatMessage.data.channel_id).getBoundingClientRect().top < container.clientHeight
                    ) {
                        this.showNewMessageAlertUp = true
                        this.showNewMessageTo = chatMessage.data.channel_id
                    }
                }

                if (this.AlertedChannelsList.indexOf(chatMessage.data.channel_id) == -1 &&
                    chatMessage.data.user_id != this.loggedInUserDoc.user_id) {

                    this.AlertedChannelsList.push(chatMessage.data.channel_id)
                    ///////////@Changing favicon
                    if (this.AlertedChannelsList.indexOf(SessionManager.getActiveChannel().channel_id) < 0) {
                        Global.changeFaviconToAlert()
                    }
                }
                if (typeof message_body.mentioned_users != 'undefined') {
                    let mentioned_users = message_body.mentioned_users
                    for (let i = 0; i < mentioned_users.length; i++) {
                        if (mentioned_users[i] == this.loggedInUserDoc.user_id && message_body.channel_id != SessionManager.getActiveChannel().channel_id) {
                            for (let j = 0; j < this.arrMentions.length; j++) {
                                if (this.arrMentions[j].channel_id == message_body.channel_id) {
                                    channelMentionNotFound = true
                                    this.arrMentions[j].count++
                                }
                            }

                            if (!channelMentionNotFound) {
                                this.arrMentions.push({
                                    channel_id: message_body.channel_id,
                                    count: 1
                                })
                            }
                        }
                    }
                }

                // Update channel excerpt and updated time
                for (let i = 0; i < this.channels.length; i++) {
                    if (this.channels[i].channel_id == chatMessage.data.channel_id) {
                        this.channels[i].last_message = chatMessage.data;
                        this.channels[i].latest_message_at = chatMessage.data.created_at;

                        // If is not the active channel, mark it with has unread messages
                        if (message_body.channel_id != SessionManager.getActiveChannel().channel_id) {
                            this.channels[i].has_unread_msgs = true;
                            this.channels[i].unread_count++;
                        }
                        if (Global.displayConventionalView()) {
                            ChannelSessionManager.sortChannels();
                        }
                        break
                    }
                }
            }
        })

        serverBus.$on(VueSignals.SOCKET_POST_EDITED, (data) => {
            for (let i = 0; i < this.channels.length; i++) {
                if (this.channels[i].channel_id == data.channel_id) {
                    ChannelSessionManager.addLastestMessage(this.channels[i]);
                    break;
                }
            }
        });

        serverBus.$on(VueSignals.SOCKET_POST_DELETED, (data) => {
            for (let i = 0; i < this.channels.length; i++) {
                if (this.channels[i].channel_id == data.channel_id) {
                    ChannelSessionManager.addLastestMessage(this.channels[i]);
                    break;
                }
            }
        });

        /**************** New channel invitation for loggedin User *******************/
        serverBus.$on(VueSignals.SOCKET_CHANNEL_INVITE, (channel_invite) => {
            if (typeof channel_invite.invitation_id != 'undefined' &&
                channel_invite.broadcast.user_ids[0] == SessionManager.getLoggedInUser().user_id) {
                channel_invite.channel_doc.invitation_id = channel_invite.invitation_id
                SessionManager.createUserByID(channel_invite.publish_user_cp_id)
                channel_invite.channel_doc.publish_user_cp_id = channel_invite.publish_user_cp_id
                let invited_channel = SessionManager.createChannel(channel_invite.channel_doc)

                if (!this.channels.some(currChannel => currChannel.channel_id == invited_channel.channel_id)) {
                    this.channels.push(invited_channel)
                    if (document.getElementById(invited_channel.channel_id).offsetTop - container.scrollTop + 250) {
                        if (document.getElementById(invited_channel.channel_id) != null &&
                            document.getElementById(invited_channel.channel_id).getBoundingClientRect().top > container.clientHeight) {
                            this.showNewMessageAlertDown = true
                            this.showNewMessageTo = invited_channel.channel_id
                        }

                        if (document.getElementById(invited_channel.channel_id) != null &&
                            document.getElementById(invited_channel.channel_id).getBoundingClientRect().top < 0 &&
                            document.getElementById(invited_channel.channel_id).getBoundingClientRect().top < container.clientHeight
                        ) {
                            this.showNewMessageAlertUp = true
                            this.showNewMessageTo = invited_channel.channel_id
                        }
                    }
                } else {
                    for (let i = 0; i < this.channels.length; i++) {
                        if (this.channels[i].channel_id == invited_channel.channel_id) {
                            this.channels[i] = invited_channel
                            break
                        }
                    }
                }
            }
        })




        serverBus.$on(VueSignals.CHANNEL_USERS_CHANGED, (user_id) => {
            if (this.loggedInUserDoc.user_id == user_id) {
                this.loggedInUserDoc = SessionManager.getLoggedInUser()
            }
        })



        /**
         * Remove pending invitations from all views
         */
        serverBus.$on(VueSignals.SOCKET_CHANNEL_REMOVE_INVITATION, (channel_remove_invite) => {
            for (let i = 0; i < this.channels.length; i++) {
                if (this.channels[i].channel_id == channel_remove_invite.channel_id &&
                    this.loggedInUserDoc.user_id != channel_remove_invite.origin.user_id &&
                    this.loggedInUserDoc.user_id == channel_remove_invite.removed_user_id) {
                    this.channels.splice(i, 1)
                    if (SessionManager.getActiveChannelId() == channel_remove_invite.channel_id) {
                        SessionManager.setFirstChannelActive()
                    }
                    break
                }
            }
        })
        /**
         * Styling responsive
         */
        serverBus.$on(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, (status) => {
            this.showLeftSidebarMobile = status

            if (this.showLeftSidebarMobile) {
                Global.setOpenMenu('left')
            } else {
                Global.setOpenMenu('')
            }
        })

        serverBus.$on(VueSignals.TOOGLE_LEFT_SIDE_BAR_MOBILE, (status) => {
            this.showLeftSidebarMobile = !this.showLeftSidebarMobile;

            if (this.showLeftSidebarMobile) {
                Global.setOpenMenu('left')
            } else {
                Global.setOpenMenu('')
            }
        })


        if (document.querySelector(".left-sidebar-holder") != null) {
            document.querySelector(".left-sidebar-holder").addEventListener('scroll', this.HandleScroll)
        }

        if (this.$route.query.hasOwnProperty('leftSideBarOpen') && this.$route.query.leftSideBarOpen == 'true') {
            // the initial status is false
            // also prevents the error of trying to navigate to the same page
            this.showLeftSidebarMobile = true;
        }

    },
    methods: {
        UsersList() {
            Global.globalValue(VueSignals.OVERLAY_TYPE, 'users_list')
            Global.globalValue(VueSignals.SHOW_MODAL, true)
        },
        CreateFolderModalCall(withChannel) {
            Global.globalValue(VueSignals.OVERLAY_TYPE, 'create_root_folder')
            Global.globalValue(VueSignals.SHOW_MODAL, true)
            Global.globalValue(VueSignals.OVERLAY_DATA, {
                "withChannel": withChannel
            })
        },
        loadChannel(channel_id) {
            if (SessionManager.getActiveChannelId() != channel_id) {
                SessionManager.setActiveChannelById(channel_id)
                this.MarkAllMessagesSeen(channel_id)
                this.loggedInUserDoc.chat_visuals.active_channel_id = channel_id
                // UserApi.UpdateUserVisual(this.loggedInUserDoc.chat_visuals)
            } else {
                // In mobile case always close the left side bar
                // This is the case when the user's have the leftsidebar opened but wants to return to the same channel
                Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, false)
            }
            // To don't directly display the keyboard in responsive when switching channels.
            if (window.screen.width <= 768 && !Global.isELectron()) {
                Global.globalValue(VueSignals.TOOGLE_TEXT_CARET, false);
            }
        },
        MarkAllMessagesSeen(channel_id) {
            for (let i = 0; i < this.channels.length; i++) {
                if (this.channels[i].channel_id == channel_id) {
                    if (this.channels[i].has_unread_msgs) {
                        ChannelSessionManager.MarkAllPostsRead();
                    }
                    this.channels[i].has_unread_msgs = false
                    this.channels[i].unread_count = 0;
                    break
                }
            }
            for (let i = 0; i < this.AlertedChannelsList.length; i++) {
                if (this.AlertedChannelsList[i] == channel_id) {
                    this.AlertedChannelsList.splice(i, 1)
                    break
                }
            }
        },
        CloseLeftSidebar() {
            this.shoswLeftSidebarMobile = false
        },
        ScrollToNew() {
            CPUtils.scroll(document.querySelector(".left-sidebar-holder"), document.getElementById(this.showNewMessageTo).offsetTop - 250)
            this.showNewMessageAlertDown = false
            this.showNewMessageAlertUp = false
        },
        HandleScroll(event) {
            if (document.getElementById(this.showNewMessageTo) != null) {
                let container = event.target
                if (container.scrollHeight - container.clientHeight - container.scrollTop <= document.getElementById(this.showNewMessageTo).offsetTop) {
                    this.showNewMessageAlertDown = false
                }

                if (container.scrollHeight - container.clientHeight - container.scrollTop >= document.getElementById(this.showNewMessageTo).offsetTop) {
                    this.showNewMessageAlertUp = false
                }
            }
        },
        ConstructChannels() {
            /****************** Get all channels **********************/
            User.getMyChannels().then(res => {
                if (typeof res.data != 'undefined' && res.data.result) {
                    SessionManager.setBroadCastingUsers(res.data.user_ids)
                    SessionManager.SetBotId(res.data.cloudplan_bot_user_id)
                    let channels = res.data.channels
                    /******************* Create oranisation users call *******************/
                    if (res.data.user_ids.length > 0) {
                        SessionManager.createAllUsersCall(res.data.user_ids).then(
                            res => {
                                for (let i = 0; i < res.data.user.length; i++) {
                                    SessionManager.createUser(res.data.user[i])
                                }
                            }).then(res => {
                            if (channels.length > 0) {
                                /****************** Creating channels and users **********************/
                                let channelsIdArray = [];
                                for (let i = 0; i < channels.length; i++) {
                                    SessionManager.createChannel(channels[i]);
                                    if (channels[i].channel_id) {
                                        channelsIdArray.push(channels[i].channel_id);
                                    }
                                }

                                SessionManager.setChannelsLastMessage(channelsIdArray);

                                if (Global.getRootWindow(window).location.href.indexOf('channel/') > -1) {
                                    let channel_id = this.$route.params.id;
                                    if (!channel_id) {
                                        channel_id = this.$route.path.split('channel/')[1];
                                    }
                                    SessionManager.setActiveChannelById(channel_id)
                                    // TODO(Alex): Maybe add here mark all messages read, bad approach: should be When
                                    // the user actually see the messages that should be marked as seen
                                    this.MarkAllMessagesSeen(channel_id);

                                    // On mobile when the user reload the page maintain the status of the leftsidebar
                                    if (window.screen.width <= 900 && this.$route.query.hasOwnProperty('leftSideBarOpen')) {
                                        Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, this.$route.query.leftSideBarOpen == 'true');
                                    }
                                } else if (Global.getRootWindow(window).location.href.indexOf('cpadmin') > -1) {
                                    this.$router.push('cpadmin');
                                } else {
                                    // Most of the times, session manager will have the proper channel, unless the api fail
                                    let channel_id = SessionManager.getLoggedInUser().chat_visuals.active_channel_id ? SessionManager.getLoggedInUser().chat_visuals.active_channel_id : SessionManager.getFirstChannel().channel_id;
                                    if (!channel_id) {
                                        channel_id = channels[0].channel_id;
                                    }
                                    SessionManager.setActiveChannelById(channel_id);
                                    // TODO(Alex): Maybe add here mark all messages read, bad approach: should be When
                                    // the user actually seen the messages that should be marked as seen
                                    this.MarkAllMessagesSeen(channel_id);
                                    // If mobile, open the LeftSidebar
                                    if (window.screen.width <= 900) {
                                        Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, true);
                                    }
                                }
                                Global.Splash(0);
                            }
                        }).then(res => {
                            /****************** Active channel  **********************/
                            let external_user_join = sessionStorage.getItem(VueSignals.EXTERNAL_USER_JOIN)
                            if (typeof external_user_join != 'undefined' && external_user_join != null) {
                                SessionManager.setActiveChannelById(external_user_join)
                                UserNotification.UserJoined(external_user_join, SessionManager.getLoggedInUser(), SessionManager.getActiveChannel().user_ids)
                                sessionStorage.setItem(VueSignals.EXTERNAL_USER_JOIN, '')
                            }

                            let contact_channel_id = sessionStorage.getItem(VueSignals.CHANNEL_ID_FROM_CONTACT_LINK)
                            let contact_user_id = sessionStorage.getItem(VueSignals.USER_ID_FROM_CONTACT_LINK)

                            if (typeof contact_channel_id != 'undefined' && contact_channel_id != null) {
                                let contactChannel = SessionManager.getChannel(contact_channel_id)
                                if (contactChannel != null) {
                                    SessionManager.UpdateChannel(contact_channel_id, {
                                        "flag": "new"
                                    })
                                    setTimeout(function() {
                                        SessionManager.UpdateChannel(contact_channel_id, {
                                            "flag": " "
                                        })
                                    }, 3000)
                                    SessionManager.setActiveChannelById(contact_channel_id)
                                } else {
                                    ChannelApi.RegisterByPublicContact(contact_channel_id, Global.getSessionIdCookie()).then(res => {
                                        if (res.data.result) {
                                            res.data.channel.flag = "new"
                                            SessionManager.createChannel(res.data.channel)
                                            SessionManager.UpdateChannel(contact_channel_id, {
                                                "flag": "new"
                                            })
                                            setTimeout(function() {
                                                SessionManager.UpdateChannel(contact_channel_id, {
                                                    "flag": " "
                                                })
                                            }, 3000)
                                            SessionManager.setActiveChannelById(contact_channel_id)
                                        }
                                    })
                                }
                                sessionStorage.setItem(VueSignals.CHANNEL_ID_FROM_CONTACT_LINK, '')
                            }

                            if (typeof contact_user_id != 'undefined' && contact_user_id != null) {
                                UserApi.RegisterByPublicContact(contact_user_id, Global.getSessionIdCookie()).then(res => {
                                    if (res.data.result) {
                                        res.data.channel.flag = "new"
                                        SessionManager.createChannel(res.data.channel)
                                        SessionManager.UpdateChannel(res.data.channel.channel_id, {
                                            "flag": "new"
                                        })
                                        setTimeout(function() {
                                            SessionManager.UpdateChannel(contact_channel_id, {
                                                "flag": " "
                                            })
                                        }, 3000)
                                        SessionManager.setActiveChannelById(res.data.channel.channel_id)
                                    } else {
                                        if (res.data.reason == "channel_already_exists") {
                                            SessionManager.UpdateChannel(res.data.channel_id, {
                                                "flag": "new"
                                            })
                                            setTimeout(function() {
                                                SessionManager.UpdateChannel(contact_channel_id, {
                                                    "flag": " "
                                                })
                                            }, 3000)
                                            SessionManager.setActiveChannelById(res.data.channel_id)
                                        }
                                    }
                                })

                                sessionStorage.setItem(VueSignals.USER_ID_FROM_CONTACT_LINK, '')
                            }


                        })
                    }
                }
            }).then(res => {
                /****************** Websocket Init  **********************/
                ChannelHandler.init(SessionManager)
                MainApi.socketSetup()
                UserApi.getMentions().then(res => {
                    if (typeof res.data != 'undefined' && res.data.length > 0) {
                        Global.globalValue(VueSignals.LOADED_MENTIONS, res.data)
                    }
                })
            })
        },
        openChooseCreateChannelModal() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true);
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.CHOOSE_CREATE_CHANNEL);
        },
        openChannelsArrangeToolModal() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true);
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.CHANNELS_ARRANGE_TOOL);
        },
    }
}
